
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events/sdks/http",
      function () {
        return require("private-next-pages/events/sdks/http.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/events/sdks/http"])
      });
    }
  